import { useContext } from "react";
import { CompanyContext } from "@/components/CompanyList/CompanyContext";
import PropTypes from "prop-types";

import { CapsuleIcon } from "../../../../client/assets/icons/common/CapsuleIcon";
import { SyringeIcon } from "../../../../client/assets/icons/common/SyringeIcon";

export const MedicationDetails = ({ classNames }) => {
	const { company } = useContext(CompanyContext);
	const { formats, actives } = company?.fields || {};

	if (!formats && !actives) return null;

	return (
		<div className={classNames?.wrapper}>
			{formats ? (
				<p className={classNames?.format}>
					<SyringeIcon className={classNames?.formatIcon} />
					{formats}
				</p>
			) : null}
			{actives ? (
				<p className={classNames?.actives}>
					<CapsuleIcon className={classNames?.activesIcon} />
					{actives}
				</p>
			) : null}
		</div>
	);
};

MedicationDetails.propTypes = {
	classNames: PropTypes.shape({
		wrapper: PropTypes.string,
		format: PropTypes.string,
		formatIcon: PropTypes.string,
		actives: PropTypes.string,
		activesIcon: PropTypes.string,
	}),
};
